var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#25CC7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8702 39.4063L41.4424 39.4063L41.4424 40.0264L34.8702 40.0264L34.8702 39.4063Z",
    fill: "#25CC7C",
    stroke: "#25CC7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3457 43.5024L38.9659 43.5024L38.9659 35.9301L37.3457 35.9301L37.3457 43.5024Z",
    fill: "#FBA622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3125 23.0625H36.875V22.25C36.8737 21.8194 36.7021 21.4068 36.3976 21.1024C36.0932 20.7979 35.6806 20.6263 35.25 20.625H28.75C28.3194 20.6263 27.9068 20.7979 27.6024 21.1024C27.2979 21.4068 27.1263 21.8194 27.125 22.25V23.0625H24.6875C24.2569 23.0638 23.8443 23.2354 23.5399 23.5399C23.2354 23.8443 23.0638 24.2569 23.0625 24.6875V41.75C23.0638 42.1806 23.2354 42.5932 23.5399 42.8976C23.8443 43.2021 24.2569 43.3737 24.6875 43.375H32V41.75H24.6875V24.6875H27.125V27.125H36.875V24.6875H39.3125V33.625H40.9375V24.6875C40.9362 24.2569 40.7646 23.8443 40.4601 23.5399C40.1557 23.2354 39.7431 23.0638 39.3125 23.0625ZM35.25 25.5H28.75V22.25H35.25V25.5Z",
    fill: "#25CC7C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenIcon);
export default __webpack_public_path__ + "static/media/greenIcon.1f19271badc8f69d5381af18be386c9e.svg";
export { ForwardRef as ReactComponent };